module.exports = __webpack_public_path__ + "./fonts/fontawesome-webfontd41d.eot";